import { connect } from 'react-redux';
import AddPersonDialog from './AddPersonDialog';
import { addPersonBegin, getPersonTypeFormByIdBegin } from '../../../store/actions/person.actions';
import { getPersonTypeForm, getPersonTypesList } from '../../../store/selectors/person.selectors';

const mapStateToProps = (state: any) => {
    const personTypes = getPersonTypesList(state);
    const personTypeForm = getPersonTypeForm(state);
    return { personTypes, personTypeForm };
};
const mapDispatchToProps = {
    addPerson: addPersonBegin,
    getPersonTypeFormById: getPersonTypeFormByIdBegin,
};
export default connect(mapStateToProps, mapDispatchToProps)(AddPersonDialog);
